import React from 'react'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

export default function(ComposedComponent) {
  @withGraphQL(
    gql`
      query me {
        me {
          _id
          roles
        }
      }
    `
  )
  class isAdmin extends React.Component {
    static propTypes = {
      me: PropTypes.func
    }
    render() {
      const rol = this.props.me.roles ? this.props.me.roles[0] : ''
      let url = false
      if (window.location.href.match('admin')) url = true
      return <ComposedComponent {...this.props} admin={rol} url={url} />
    }
  }
  return isAdmin
}



// WEBPACK FOOTER //
// ./src/App/Decorators/isAdmin.js